import { render, staticRenderFns } from "./index.vue?vue&type=template&id=692ac3e1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('692ac3e1')) {
      api.createRecord('692ac3e1', component.options)
    } else {
      api.reload('692ac3e1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=692ac3e1&", function () {
      api.rerender('692ac3e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/categories/index.vue"
export default component.exports